<template>
  <!-- <div>ssss</div> -->
  <div>
    <basic-container>
      <div class="page-container partner-manage-page">
        <div class="query-form-wrap">
          <el-form :inline="true"
                   :model="form"
                   :size="formSize">
            <el-form-item>
              <el-input clearable
                        v-model="form.appName"
                        placeholder="应用名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button :loading="listLoading"
                         icon="el-icon-search"
                         type="primary"
                         @click="handleSearch">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-form :inline="true">
          <el-form-item>
            <el-button @click="openEdit"
                       icon="el-icon-plus"
                       v-auth="'contenmanage_appconfig_add'"
                       size="small"
                       type="primary">新增</el-button>
            <el-button type="danger"
                       icon="el-icon-delete"
                       size="small"
                       @click="batchDel"
                       v-auth="'contenmanage_appconfig_delete'">删除</el-button>
          </el-form-item>
        </el-form>

        <el-table :cell-style="{'text-align':'center'}"
                  :header-cell-style="{'text-align':'center'}"
                  :max-height="tableHeight"
                  v-loading="listLoading"
                  element-loading-text="加载中"
                  border
                  :data="tableDataList"
                  @selection-change="handleSelectionChange">

          <el-table-column type="selection"
                           width="55"></el-table-column>
          <el-table-column prop="id"
                           fixed
                           label="ID"
                           align="center"
                           header-align="center"
                           width="170">
          </el-table-column>
          <el-table-column prop="appName"
                           align="center"
                           header-align="center"
                           label="应用名称"
                           width="180">
          </el-table-column>
          <el-table-column prop="appLogo"
                           align="center"
                           header-align="center"
                           label="应用图标"
                           width="200">
            <template slot-scope="scope">
              <img :src="scope.row.appLogo"
                   height="30px" />
            </template>
          </el-table-column>
          <el-table-column prop="androidPkg"
                           align="center"
                           header-align="center"
                           label="安卓包名"
                           width="200">

          </el-table-column>
          <el-table-column prop="androidSchema"
                           align="center"
                           header-align="center"
                           label="安卓Schema"
                           width="180">
          </el-table-column>
          <el-table-column prop="androidDownloadUrl"
                           align="center"
                           header-align="center"
                           label="安卓下载地址"
                           width="180">
          </el-table-column>

          <el-table-column prop="iosAppId"
                           align="center"
                           header-align="center"
                           label="iOS应用ID"
                           width="180">
          </el-table-column>
          <el-table-column prop="ios Schema"
                           align="center"
                           header-align="center"
                           label="iosSchema"
                           width="180">
          </el-table-column>
          <el-table-column prop="updateUserName"
                           align="center"
                           header-align="center"
                           label="修改人"
                           width="180">
          </el-table-column>
          <el-table-column prop="updateTime"
                           align="center"
                           header-align="center"
                           width="150"
                           label="修改时间">
          </el-table-column>
          <el-table-column width="200"
                           fixed="right"
                           label="操作">
            <template slot-scope="scope">
              <el-button @click="openEdit(scope.row)"
                         v-auth="'contenmanage_appconfig_update'"
                         v-if="scope.row.reviewStatus!=1&&scope.row.reviewStatus!=3"
                         icon="el-icon-edit"
                         size="small"
                         type="text">修改</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="table-pagination">
          <TablePagination :page-size.sync="pageConfig.size"
                           :total="total"
                           :current-page.sync="pageConfig.current"
                           @change="handlePageChange" />
        </div>
      </div>

      <el-dialog :title="checkItem.id?'修改':'新增'"
                 :visible.sync="showEdit"
                 append-to-body
                 width="40%"
                 :before-close="handleAddOrEditClose"
                 top="5vh">
        <el-form ref="ruleForm"
                 :rules="rules"
                 :model="checkItem"
                 label-width="80px">
          <el-form-item label="应用名称"
                        prop="appName">
            <el-input placeholder="请输入应用名称"
                      v-model="checkItem.appName"></el-input>
          </el-form-item>
          <el-form-item label="应用图标"
                        prop="appLogo"
                        ref="fileAppLogoRule">
            <el-upload action="#"
                       list-type="picture-card"
                       :on-preview="handleImgsPreview"
                       :auto-upload="false"
                       :file-list="fileImgesList"
                       :on-exceed="uploadOnExceed"
                       :on-change="handleChangeImgs"
                       :on-remove="handleRemoveImgs">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogImageVisible">
              <img width="100%"
                   :src="checkItem.appLogo"
                   alt="">
            </el-dialog>
          </el-form-item>
          <el-form-item label="安卓配置"></el-form-item>
          <el-form-item label="包名">
            <el-input placeholder="请输入应用包名"
                      v-model="checkItem.androidPkg"></el-input>
          </el-form-item>
          <el-form-item label="schema">
            <el-input placeholder="请输入应用schema"
                      v-model="checkItem.androidSchema"></el-input>
          </el-form-item>
          <el-form-item label="下载地址">
            <el-input placeholder="请输入下载地址"
                      v-model="checkItem.androidDownloadUrl"></el-input>
          </el-form-item>
          <el-form-item label="苹果配置"></el-form-item>
          <el-form-item label="应用ID">
            <el-input placeholder="请输入应用ID"
                      v-model="checkItem.iosAppId"></el-input>
          </el-form-item>
          <el-form-item label="schema">
            <el-input placeholder="请输入应用schema"
                      v-model="checkItem.iosSchema"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="submitChange('ruleForm')"
                     size="small"
                     type="primary"
                     icon="el-icon-circle-check">保存</el-button>
          <el-button @click="handleAddOrEditClose"
                     size="small"
                     icon="el-icon-circle-close">取消</el-button>
        </div>
      </el-dialog>
    </basic-container>

  </div>
</template>
<script>
import { merge, debounce, deepCopy } from '@/util/common';
import ListMixins from '@/util/mixins/listPage';
import { videoappSubmit, videoappPage, videoappRemove } from "@/api/contentManage/index";
import { putFile } from "@/api/app";
//import {mapGetters} from "vuex";
import ApproveLogPopups from '@/components/ApproveLogPopups';

export default {
  name: 'videoContent',
  mixins: [ListMixins],
  data () {
    return {
      listLoading: false,
      form: {     //查询的时候需要用到的参数
        appName: ''
      },
      delids: '',
      checkItem: {  // 选中编辑之中的数据
        id: '',
        appName: '',
        androidPkg: '',
        androidSchema: '',
        androidDownloadUrl: '',
        iosAppId: '',
        iosSchema: ''
      },
      tableDataList: [],
      pageConfig: {},
      total: 0,
      showEdit: false,
      rules: {
        appName: [
          { required: true, message: '请输入应用名称', trigger: 'blur' }
        ],
        appLogo: [
          { required: true, message: '请上传icon', trigger: 'blur' }
        ]
      },
      fileImgesList: [],
      dialogImageVisible: false // 是否显示放大图片
    }
  },
  components: {
    ApproveLogPopups
  },
  created () {
    this.getList();
    console.log(this.permission)
  },
  methods: {
    handleRemoveImgs () {
      //清空背景图片
      this.checkItem.appLogo = ''
    },
    handleSelectionChange (row) {
      console.log('[handleSelectionChange]', row)
      let selectIds = []
      row.forEach(function (item) {
        selectIds.push(item.id);
      });
      this.delids = selectIds.toString()
      console.log('[handleSelectionChange] 选择的ids', selectIds.toString())
    },
    // 批量删除
    batchDel () {
      if (this.delids != '') {
        this.$confirm('确定要删除选中的数据吗？', '提示', {
          type: 'warning'
        }).then(() => {
          this.videoappRemove(this.delids)
        })
      } else {
        this.$message.warning(`请选择要删除的记录！`);
      }
    },
    handerDel (row) {
      this.$confirm('确定要删除选中的数据吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.videoappRemove(row.id)
      })
    },
    //删除
    videoappRemove (pdata) {
      videoappRemove(pdata).then(res => {
        if (res.data.code === 200) {
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    getList () {
      this.listLoading = true
      console.log('[getList]', this.form)
      const query = merge({}, this.form, this.pageConfig)
      let onSuccess = res => {
        this.listLoading = false
        console.log('[result data ]', res)
        if (res.data.code === 200) {
          this.tableDataList = res.data.data.records
          this.pageConfig.size = res.data.data.size
          this.pageConfig.current = res.data.data.current
          this.total = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }

      videoappPage(query).then(onSuccess).catch(() => { this.listLoading = false })
    },
    openEdit (row) {
      console.log('[openEdit]', row)
      this.showEdit = true
      this.showProgress = false
      this.authProgress = 0
      if (row.id) {
        this.checkItem = deepCopy(row)
        //app图标
        this.fileImgesList = [{ name: "", url: row.appLogo }]
      } else {
        this.checkItem = {}
        this.fileImgesList = []
      }
    },
    // 上传图片
    handleChangeImgs (file, fileList) {
      console.log('[handleChangeImgs]', file)
      console.log('[handleChangeImgs fileList]', fileList.slice(0))
      this.fileImgesList = [fileList[fileList.length - 1]] //永远只保持一个文件
      const formData = new FormData()
      formData.append('file', file.raw)
      putFile(formData).then(res => {
        if (res.data.code === 200) {
          this.checkItem.appLogo = res.data.data.link
          this.$refs.fileAppLogoRule.clearValidate()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleImgsPreview (file) {
      this.checkItem.appLogo = file.url;
      this.dialogImageVisible = true;
    },
    uploadOnExceed () {
      this.$message.warning(`当前限制只能选择 1 个文件，如需替换请删除后重新上传!`);
    },
    //关闭弹窗编辑或者新增
    handleAddOrEditClose () {
      console.log("[handleAddOrEditClose] 取消关闭弹窗清理数据")
      this.showEdit = false
      this.fileImgesList = []; //清空图片列表
      this.checkItem = {}
    },
    //提交更改内容
    submitChange: debounce(function (formName) {
      console.log("[submitChange formName:]", formName)
      console.log("[submitChange]", this.checkItem)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          videoappSubmit(this.checkItem).then(res => {
            if (res.data.code === 200) {
              this.showEdit = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          return false;
        }
      })

    }, 1000, false)
  }
}
</script>
<style lang="scss">
.table-pagination {
  margin-top: 20px;
  text-align: right;
}
.partner-manage-page {
  .cell-content {
    color: #008080;
    cursor: pointer;
    text-decoration: underline;
    display: inline-block;
    padding: 6px 10px;
    line-height: 1.3em;
  }
}
</style>
